/* 
 * Object to get/set data related to checkout
 * TODO: 
 *  - refactor cart actions and put them in @api/cart
 *  - refactor these setBaseUrl/getUrl to use @api/base-url
 */

import request from '@/Utilities/httpRequest';
import utilities from '@/Utilities/common';


export default {
    baseUrl: null, 

    setBaseUrl (url) {
        if(url && url.length > 0){
            const curLocation = window.location;
            const base = curLocation.protocol+'//'+curLocation.hostname;
            if(curLocation.port == '8080' && url.indexOf(':8080/') !== -1){
                // this is development env running in local mode
                console.log('this is development env running in local mode');
                url = process.env.VUE_APP_DEV_STORE;
            }
            const oUrl = new URL(url, base);
            const path = oUrl.pathname.split("/");
            
            this.baseUrl = oUrl.origin + "/" + path[1] + "/" + path[2];
            //console.log('setBaseUrl ', url, oUrl, path);
            //console.log('this.baseUrl ', this.baseUrl);
        }    
    },
    
    getUrl (controllerAction) {
        //console.log('get URL for ', controllerAction)
        if(this.baseUrl === null) {
            //console.log('set base URL from ', window.location.href);
            // parse base URL from current location
            this.setBaseUrl(window.location.href);
        }
        let url = this.baseUrl;
        if(typeof controllerAction !== 'undefined'){
            url = url + "/" + controllerAction;
        }
        return url;
    },

    // getCart () {
    //     return request.get(this.getUrl('checkout/index'), {}, false);
    // },
    
    load (url, callback, callbackError) {
        this.setBaseUrl(url);
        return request.get(url, {}, false)
            .then(response => {
                // promissed resolved, do basic checks on response
                if (!response.hasOwnProperty('data')) {
                    throw new Error("Bad response");
                }
                return response.data;
            })
            .then(response => {
                // handle success
                callback(response);
            })
            .catch(error => {
                // handle error
                callbackError(error);
            });
    },

    async updateItemQuantity (lineId, quantity) {
        const data = {
            lin: lineId,
            qty: quantity,
            validate: 1,
            vueMode: true
        };
        return await request.get(this.getUrl('cart/update'), data, false);
    },
    async removeItem (lineId) {
        const data = {
            lin: lineId,
            validate: 1,
            vueMode: true
        };
        return await request.get(this.getUrl('cart/remove'), data, false);
    },

    async removeProductSuggestion (sku) {
        return await request.get(this.getUrl('cart/removeProductSuggestion'), sku, false);
    },

    async submitCoupon (couponCode) {
        const data = {
            cpn: couponCode,
        };
        return await request.post(this.getUrl('checkout/index'), data, false);
    },

    async removeCoupon (lineId, couponCode) {
        const data = {
            "cpn-rm": lineId,
            "cpn-id": couponCode,
        };
        return await request.get(this.getUrl('checkout/index'), data, false);
    },

    async removeCoupons() {
        return await request.get(this.getUrl('cart/remove-coupons'), {validate: 1}, false);
    },

    async updateCouponOffer (lineId, sku, type) {
        const data = {
            "line_id": lineId,
            "type": type,
            "sku": sku,
            "qty": 1,
        };
        return await request.get(this.getUrl('cart/update-offer'), data, false);
    },

    async changeItem (lineId, sku) {
        const data = {
            "lin": lineId,
            "sku": sku,
        };
        return await request.get(this.getUrl('cart/upgrade'), data, false);
    },

    async removeProductPoints() {
        return await request.get(this.getUrl('points/remove-offers'), {}, false);
    },

    async addToCart (sku, quantity, type, suggested) {
        const data = {
            sku: sku,
            qty: quantity,
            type: type,
            vueMode : true,
            oti: utilities.getMubOtiData(),
            suggested: typeof suggested !== 'undefined' && suggested ? '1' : ''
        };
        return await request.post(this.getUrl('cart/add'), data, false);
    },

    async addGoodies (params) {
        return await request.post(this.getUrl('cart/add-goodies'), params, false);
    },

    async removeGoodies() {
        return await request.get(this.getUrl('cart/remove-goodies'), {validate: 1}, false);
    },
    
    async giftOrderForm(params) {
        return await request.post(this.getUrl('checkout/gift-order'), {GiftCart: params}, false);
    },

    async deleteGiftOrder() {
        return await request.post(this.getUrl('checkout/delete-gift'), {}, false);
    },

    async getSuggestionProducts() {
        return await request.get(this.getUrl('checkout/chiclets'), null, false);
    },

    async nextStepRequest(url, params) {
        const response = await request.get(url, params, false);
        let errors = (response.data?.header?.error ?? []);
        let responseError = errors.length > 0;
        let result = response.data.result;
        try {
            if (!responseError && result) {
                let ajaxParams = result.ajaxParams;
                if (ajaxParams.hasOwnProperty('redirect')) {
                    window.location.href = ajaxParams.redirect;
                }
                let error = ajaxParams?.Error ?? null;
                if(error){
                    throw new TypeError(error);
                }
            } else {
                if(responseError){
                    let error = errors[0]["msg"] ?? null;
                    if(error){
                        throw new TypeError(error);
                    }
                }
            }

        } catch (error) {
            let msg = error?.message ?? null;
            if(msg){
                throw new TypeError(msg);
            }
            //console.log('next Step Request error!: ', response.data);
        }
    },

    async actionRequest(url, params) {
        // in test
        const response = await request.get(url, params, false);
        let responseError = response.data.hasError;
        let responseMsg = response.data.msg ? response.data.msg : null;
        let result = null;
        //console.log('action request:', response);
        try {
            if (!responseError) {
                result = response.data.result;
            } else {
                console.log('action request failed: ', responseMsg);
            }

        } catch (error) {
            console.log('action request error!: ', error);
        }
        
        return result;
    },

    setLabelDeliveryDate(date, kStrings){
        if(date == null || date == ''){
            return '';
        }
        return (date && date.length > 11 ? kStrings.kDELIVERY_UNTIL : kStrings.kDELIVERY_FROM) + ' ' + date;
    },
    setHeaderLabelDeliveryDate(date, dateDeliveryExtensive, extraPrefix = '', kStrings){
        if(date == null || dateDeliveryExtensive == null || dateDeliveryExtensive == ''){
            return '';
        }
        return (extraPrefix ? `${extraPrefix}: ` : '') + (date && date.length > 11 ? kStrings.kDELIVERY_UNTIL_SHIPPING_CHECKOUT : kStrings.kDELIVERY_FROM_SHIPPING_CHECKOUT) + ' ' + dateDeliveryExtensive;
    },

};
